import { Component, OnInit } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { MenuService } from '../../../services';

@Component({
  selector: 'app-formly-textarea',
  templateUrl: './formly-text-area.component.html',
  styleUrl: './formly-text-area.component.scss',
})
export class FormlyTextAreaComponent extends FormlyFieldBaseComponent implements OnInit {
  hasScrollbar: boolean;

  defaultOptions = {
    props: { rows: 5 },
  };

  constructor(public menuService: MenuService) {
    super();
  }

  ngOnInit() {
    if (this.menuService.isReadOnly) {
      this.props.readonly = true;
      this.props.tabindex = -1;
    }
  }

  onKeyUp(event: any) {
    this.hasScrollbar = event.target.clientHeight < event.target.scrollHeight;
  }
}
